// DEPENDENCIES
import React from 'react';
// COMPONENTS   
import { Fade } from 'react-awesome-reveal';
// ICONS
import { AiOutlineLoading } from 'react-icons/ai'
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';
import LogoBlock from './LogoBlock';


const LoadingScreen = (props) => {

    return (
        <CustomBlock className="loading-screen-container">
        <Fade>
            <LogoBlock
                height={120}
            />
            <AiOutlineLoading className="loading-indicator rotating primary--clr" size={45} />
        </Fade>
    </CustomBlock>
    );
}

export default LoadingScreen;